export default "dist/b6c637988eaf0e65d76f5e1098e772c6.png";